import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { HistoryItemBody } from './item-body';
import { ItemCell } from './item-cell';
import { messages } from './messages';
import style from './style.module.less';
import { getInventoryHistoryForProduct } from '../../../../../../../../src/store/inventory/inventory.api';
import { ProductDetailsContext } from '../../../../../context';

/**
 * @param {object} props
 * @param {string} [props.inventoryLocationId]
 * @param {string} [props.lotUuid]
 * @returns {JSX.Element}
 */

export const HistoryItems = ({ inventoryLocationId = undefined, lotUuid = '' }) => {
  const { productId } = useContext(ProductDetailsContext);
  const [history, setHistory] = useAsyncSafeState([]);
  const [isLoading, setIsLoading] = useAsyncSafeState(true);

  useEffect(() => {
    const promise = getInventoryHistoryForProduct(productId, inventoryLocationId, lotUuid);
    promise.promise
      .then((response) => {
        const data = response.data || [];
        setHistory(data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    return () => promise?.cancel();
  }, [productId, inventoryLocationId, lotUuid, setHistory, setIsLoading]);

  return (
    <div>
      <div
        className={classnames({
          [style['items-header-extended']]: !inventoryLocationId,
          [style['items-header']]: inventoryLocationId,
        })}
      >
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryUnitsHeader} />
        </ItemCell>
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryCostHeader} />
        </ItemCell>
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryDateHeader} />
        </ItemCell>
        {!inventoryLocationId && (
          <>
            <ItemCell>
              <FormattedMessage {...messages.inventoryHistoryLotIDHeader} />
            </ItemCell>
            <ItemCell>
              <FormattedMessage {...messages.inventoryHistoryExpirationDateHeader} />
            </ItemCell>
          </>
        )}
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryUserHeader} />
        </ItemCell>
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryDescriptionHeader} />
        </ItemCell>
        <ItemCell>
          <FormattedMessage {...messages.inventoryHistoryTypeHeader} />
        </ItemCell>
      </div>
      {isLoading ? (
        <div className={style['no-records-or-loading']}>
          <LoadingIndicator className={style['loading-icon']} />
        </div>
      ) : null}
      {!isLoading &&
        history.map((item, index) => <HistoryItemBody key={index} historyItem={item} inventoryLocationId={inventoryLocationId} />)}
      {!isLoading && history.length === 0 && (
        <div className={style['no-records-or-loading']}>
          <FormattedMessage {...messages.inventoryHistoryNoRecords} />
        </div>
      )}
    </div>
  );
};
